import { InboxOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { useSetState } from 'ahooks'
import { Button, message, Upload, Modal, Tooltip } from 'antd'
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { get } from 'lodash-es'
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {
  // getToken, baseURL,
  useFileUrlPrefix,
  CustomFileUpload,
} from 'shj-utils'
import request, { METHODS } from '@/api'

export const customUpload = new CustomFileUpload({
  request,
  message,
  url: '/file-web/file/upload',
})

export enum AcceptType {
  picture = '.png,.jpg,.jpeg,.gif,.webp',
  files = 'application/vnd.ms-excel,aplication/zip,application/msword,application/vnd.ms-powerpoint,application/vnd.ms-excel,text/plain,application/vnd.ms-works',
  autocad='.dwg,.pdf,.dxf,.dwt',
  pdf='.pdf',
}

function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const ImageUpload = (props: any) => {
  const { limit = 8, fileList, onChange, onPreview, type = 'DragableUploadList', size = 10, ...rest } = props
  const [state, setState] = useSetState({
    fileList: [] as any,
    previewImage: '',
    previewVisible: false,
    previewTitle: '',
  })

  const [imagePrefix] = useFileUrlPrefix()

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = state.fileList[dragIndex];
      state.fileList.splice(dragIndex, 1)
      state.fileList.splice(hoverIndex, 0, dragRow)
      setState({
        fileList: [...state.fileList]
      });
      onChange && onChange([...state.fileList])
    },
    [state.fileList],
  );
  /*const onChange = ({ fileList: newFileList }) => {
    setState({
      fileList: [...newFileList]
    });
  };*/
  const DragableUploadListItem = ({ originNode, moveRow, file, fileList }) => {
    const ref = useRef(null);
    const index = fileList.indexOf(file);
    const [{ isOver, dropClassName }, drop] = useDrop({
      accept: type,
      collect: (monitor) => {
        const { index: dragIndex } = monitor.getItem() || {};
        if (dragIndex === index) {
          return {};
        }
        return {
          isOver: monitor.isOver(),
          dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
        };
      },
      drop: (item) => {
        moveRow(item.index, index);
      },
    });
    const [, drag] = useDrag({
      type,
      item: {
        index,
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });
    drop(drag(ref));
    const errorNode = <Tooltip title="Upload Error">{originNode.props.children}</Tooltip>;
    return (
      <div
        ref={ref}
        className={`ant-upload-draggable-list-item ${isOver ? dropClassName : ''}`}
        style={{
          cursor: 'move',
          height: '100%'
        }}
      >
        <div style={{ position: 'relative', height: '100%' }}>
          {file.status === 'error' ? errorNode : originNode}
          {
            index === 0 && (
              <div
                style={{
                  position: 'absolute',
                  padding: '0 4px',
                  right: '0',
                  // transform: 'translateX(-50%)',
                  bottom: 0,
                  background: 'var(--theme-color)',
                  borderRadius: '4px',
                  color: '#fff'
                }}>
                  主图
                </div>
            )
          }
        </div>
      </div>
    );
  };
  
  useEffect(() => {
    if (fileList) {
      setState({ fileList })
    }
  }, [props.fileList])

  useEffect(() => {
    console.log(props.value);
    if (Array.isArray(props.value)) {

      setState({ fileList: props.value })
    }
  }, [props.value])

  const handlePreview = async (file: any) => {
    // console.dir(file);
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    onPreview && onPreview(file)
    setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    })
  }

  const handleChange = ({ file, fileList }: any) => {
    // console.logList('file', file);
    if (file.status === 'done') {
      if (props.setFileUrl) {
        fileList = props.setFileUrl && props.setFileUrl(fileList)
      } else {
        fileList = fileList.map((d: any) => {
          if (d.response?.data) {
            d.url = d.response?.data?.fileUrl
          }
          return d
        })
      }
    }
    setState({ fileList })
    // console.log('fileList', fileList, file.status)
    if (['removed', 'done'].includes(file.status)) {
      // console.logList(fileList.map((d: any) => d.response.data[0]));
      onChange && onChange(fileList)
    }
  }

  const beforeUpload = (file: any) => {
    const isLt20M = file.size / 1024 / 1024 < size;
    if (!isLt20M) {
      message.info(`图片大小不能大于${size}MB`);
      return Upload.LIST_IGNORE;
    }
  }

  // const actionOrigin =
  //   process.env.NODE_ENV === 'development' ? window.rawWindow?.location?.origin || '' : ''
  const uploadProps = {
    // action: actionOrigin + baseURL + '/api-portal/file/upload',
    customRequest: customUpload.upload,
    listType: 'picture-card',
    fileList: state.fileList,
    onPreview: props.listType === 'text' ? null : handlePreview,
    onChange: handleChange,
    beforeUpload,
    // headers: {
    //   Authorization: getToken(),
    // },
    maxCount: limit,
    disabled: props.readonly,
    accept: '.png,.jpg,.jpeg,.gif,.webp',
    itemRender: (originNode, file, currFileList) => (
      <DragableUploadListItem
        originNode={originNode}
        file={file}
        fileList={currFileList}
        moveRow={moveRow}
      />
    ),
    ...rest,
  }

  const handleCancel = () => {
    setState({ previewVisible: false })
  }

  return (
    <div>
      <DndProvider backend={HTML5Backend}>
        <Upload
            {...uploadProps}
        >
          {fileList.length < limit && <div>
            <PlusOutlined/>
            <div
                style={{
                  marginTop: 8,
                }}
            >
              上传
            </div>
          </div>}
        </Upload>
      </DndProvider>
      <Modal title="预览" open={state?.previewVisible} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={state?.previewImage} />
      </Modal>
      {rest?.toolTip ? <div style={{marginTop: 5, color: '#969696'}}>{rest?.toolTip}</div> : null}
    </div>
  )
}
export default ImageUpload
